var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWasteWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.3 55.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 28.3,
    width: 24.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.8,
    width: 24.3,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,55.11A18.23,18.23,0,0,1,6.69,36.9V9.3H16.91V36.9a8,8,0,0,0,16,0H43.11A18.23,18.23,0,0,1,24.9,55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.11,25.7H33.89A18.23,18.23,0,0,1,52.1,7.49V17.71A8,8,0,0,0,44.11,25.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    width: 5.8,
    height: 24.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWasteWater);
export default __webpack_public_path__ + "static/media/icon-waste-water.5210b34f.svg";
export { ForwardRef as ReactComponent };